import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Layout from './Layout';

const queryClient = new QueryClient();

const NewsletterFeedBanner = ({ currentUser, newsletterId, feedType, gdpr, gdprColorScheme }) => (
  <QueryClientProvider client={queryClient}>
    <Layout
      newsletterId={newsletterId}
      currentUser={currentUser}
      feedType={feedType}
      gdpr={gdpr}
      gdprColorScheme={gdprColorScheme}
    />
  </QueryClientProvider>
);

export default NewsletterFeedBanner;
